module.exports = __webpack_public_path__ + "static/media/ic_trust_pilot.8ec77555.png";